import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from "../BaseApi";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AttendanceAdjustmentSlice = createSlice({
    name: 'attendanceAdjustmentSection',
    initialState: {
        getAttendancePeriodActive: null,
        getAttendancePeriodReview: null,
        getAttendancePeriodRequest: null
    },
    reducers: {},
    extraReducers: {
        'attendanceAdjustmentSection/getAttendancePeriodActive/fulfilled': (state, action) => {
            state.getAttendancePeriodActive = ResponseApi(action.payload);
        },
        'attendanceAdjustmentSection/getAttendancePeriodReview/fulfilled': (state, action) => {
            state.getAttendancePeriodReview = ResponseApi(action.payload);
        },
        'attendanceAdjustmentSection/getAttendancePeriodRequest/fulfilled': (state, action) => {
            state.getAttendancePeriodRequest = ResponseApi(action.payload);
        }
    },
});

export const {} = AttendanceAdjustmentSlice.actions;

export default AttendanceAdjustmentSlice.reducer;
